export const useMobileDevice = (initialState = false) => {
  const isMobile = useState<boolean>('is-mobile', () => initialState)
  const BREAKPOINT = 1100

  function checkIsMobile(document: Document) {
    return document.documentElement.clientWidth < BREAKPOINT
  }

  onBeforeMount(() => window.addEventListener('resize', () => {
    isMobile.value = checkIsMobile(document)
  }))
  onMounted(() => {
    isMobile.value = checkIsMobile(document)
  })

  return { isMobile }
}
